export const VERSION_DROPDOWN_WIDTH = 420;
export const VERSION_SNAPSHOT_PREVIEW_LIMIT = 3;
export const VERSION_TAG_PREVIEW_LIMIT = 2;
export const VERSION_DATE_PRESETS = [
  { id: 'last7', labelKey: 'versionLast7Days', days: 7 },
  { id: 'last30', labelKey: 'versionLast30Days', days: 30 },
  { id: 'month', labelKey: 'versionThisMonth' },
  { id: 'all', labelKey: 'versionAllDates' }
] as const;
